import "./Dashboard.css";

import { message } from "antd";

export const DashboardPage = () => {
  const [_, contextHolder] = message.useMessage();

  return (
    <>
      {contextHolder}
      <div className="dashboard">
        <h1>Welcome back, Admin</h1>
      </div>
    </>
  );
};
